import ApiManager from '@/utils/ApiManager'
import Constants from '@/utils/Constants'
import Utility from '@/utils/Utility'
import Vue from 'vue'

const state = {
  categoryName: '固定画面ID',

  // model
  screenIdMstModel: [],
  
  // form
  targetId: Constants.RegisterHash,
  values: {}
}

const getters = {
  get: state => state,

  // form mode
  isRegister: state => state.targetId === Constants.RegisterHash,
  isModify: state => state.targetId !== Constants.RegisterHash,
  
  // 登録値を表示用に変換
  getValue: state => (key) => {
    try {
      let value = state.values[key]
      switch (key) {
        default:
          return value
      }
    /* eslint-disable no-new */
    } catch (e) {
      return ''
    }
  }
}

const actions = {
  /**
   * 初期データを読出し
   */
  loadModel ({commit}, {screenIdMstParams}) {
    return new Promise((resolve, reject) => {
      ApiManager.request(
        ['screenIdMst'],
        ['v1ScreenIdMstListGet'],
        [screenIdMstParams])
        .then(res => {
          let status = Utility.parseResponse(res)

          if (status.result) {
            commit('setScreenIdMstModel', res[0].data.screenIdMsts)
            console.log('screenIdMstModel', state.screenIdMstModel)
            resolve()

          } else if (status.error) {
            // エラーメッセージ表示
            reject(res)
          } else {
            // アプリケーションエラー表示
            reject(null)
          }
        })
        .catch(error => {
          // アプリケーションエラー表示
          reject(null)
        })
    })
  },

  /**
   * フォームの初期化
   */
  initRegister ({commit}) {
    commit('setTargetId', Constants.RegisterHash)
    commit('initRegister')
  },
  initModify ({commit}, {data}) {
    commit('setTargetId', data.LinkedCmsMstId)
    commit('initModify', data)
  },

  /**
   * リセット
   */
  reset ({commit}) {
    commit('reset')
  }
}

const mutations = {
  // model
  setScreenIdMstModel (state, data) {
    Vue.set(state, 'screenIdMstModel', data)
  },

  // form
  setTargetId (state, targetId) {
    state.targetId = targetId
  },
  setValues (state, values) {
    Vue.set(state, 'values', values)
  },
  setInputValue (state, {key, value}) {
    Vue.set(state.values, key, value)
  },

  // form mode
  initRegister (state) {
    Vue.set(state.values, 'inpScreenId', null)
    Vue.set(state.values, 'inpScreenName', null)
    Vue.set(state.values, 'inpServiceTypes', [])
    Vue.set(state.values, 'inpTransitionFlag', false)
    Vue.set(state.values, 'inpStatus', '')
  },
  initModify (state, data) {
    Vue.set(state, 'values', data)
    Vue.set(state.values, 'inpScreenId', data.screenId)
    Vue.set(state.values, 'inpScreenName', data.screenName)
    Vue.set(state.values, 'inpServiceTypes', data.serviceTypes)
    Vue.set(state.values, 'inpTransitionFlag', data.screenTransitionFlg)
    Vue.set(state.values, 'inpStatus', data.screenIdStatus)
  },

  // reset
  reset (state) {
    state.targetId = Constants.RegisterHash
    Vue.set(state, 'values', {})
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
